/**
 * @generated SignedSource<<5bfe6aaf8c21cbb57470fb93128fc299>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookButtonHomeHeader_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BookModal_session">;
  readonly " $fragmentType": "BookButtonHomeHeader_session";
};
export type BookButtonHomeHeader_session$key = {
  readonly " $data"?: BookButtonHomeHeader_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookButtonHomeHeader_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookButtonHomeHeader_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookModal_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "758fc0460b5055f0fa6347f93356285a";

export default node;
